//probably not needed
function showOneImageRepeatedly()
{  
  stimContainers[1].style.display="none";
  setTimeout("showTestImages()", listArrays[allColumns.indexOf('ITI')][trialRow]);
}